import { Fragment } from "react";
import { Dialog as ReactDialog, Transition } from "@headlessui/react";

export default function Dialog({
  open,
  setOpen,
  setClose,
  children,
  size = "auto",
  static: isStatic = false,
}: {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  setClose?: () => void;
  children: React.ReactNode;
  size?: "auto" | "lg";
  static?: boolean;
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <ReactDialog
        as="div"
        className="relative z-10"
        onClose={() => {
          if (setClose) setClose();
        }}
      >
        <ReactDialog.Title as="h3" className="sr-only"></ReactDialog.Title>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <ReactDialog.Panel
                className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6 max-h-[75vh] overflow-y-auto"
                style={{
                  width: "-webkit-fill-available",
                  minWidth: size === "auto" ? 300 : 800,
                }}
              >
                <div>{children}</div>
              </ReactDialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </ReactDialog>
    </Transition.Root>
  );
}
